module.exports = require("@deck.gl/react");